import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { AbstractReactiveDialogComponent } from '@app/shared/components/dialog/reactive-dialog/base/abstract-reactive-dialog-component';
import { ReactiveDialogContentComponent } from '@app/shared/components/dialog/reactive-dialog/base/reactive-dialog-content/reactive-dialog-content.component';
import { AntragChangeType, AntragRejectRequest, AntragRejectType } from '@o30/entities';

export interface AntragSelectOption<T extends AntragRejectType | AntragChangeType> {
  value: T,
  label: string
}

export interface RejectOption extends AntragSelectOption<AntragRejectType> {
}

export interface ChangeOption extends AntragSelectOption<AntragChangeType> {
}

@Component({
  selector:        'app-reject-antrag-dialog',
  templateUrl:     './reject-antrag-dialog.component.html',
  styleUrls:       ['./reject-antrag-dialog.component.scss'],
  standalone:      true,
  imports: [
    ReactiveDialogContentComponent,
    ReactiveFormsModule,
    MatButton,
    MatButtonToggleGroup,
    MatButtonToggle
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RejectAntragDialogComponent extends AbstractReactiveDialogComponent<never, AntragRejectRequest> {
  private formBuilder = inject(FormBuilder);

  protected readonly rejectOptions: RejectOption[] = [
    {
      value: AntragRejectType.REJECTED,
      label: 'Antrag ablehnen'
    },
    {
      value: AntragRejectType.CHANGE,
      label: 'Antrag überarbeiten'
    }
  ];

  protected readonly changeOptions: ChangeOption[] = [
    {
      value: AntragChangeType.CHANGE_BY_MAKLERBETREUER,
      label: 'Änderung erfolgt von Maklerservice'
    },
    {
      value: AntragChangeType.CHANGE_BY_MAKLER,
      label: 'Änderung erfolgt vom Makler'
    }
  ];

  protected readonly formGroup = this.formBuilder.group({
    rejectType: this.rejectOptions[0].value,
    changeType: null
  });

  constructor() {
    super();
    this.dialogInputData.title = 'Antrag ändern/ablehnen';
  }

  protected confirmSelection() {
    this.dialogRef.close({
      status: 'success',
      data:   this.formGroup.value as AntragRejectRequest
    });
  }

  get isChangeSelected(): boolean {
    return this.formGroup.value.rejectType === AntragRejectType.CHANGE;
  }
}
